module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict7.6a746ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict7.png
// module id = kS8X
// module chunks = 0